export const ATTRIBUTE_CONSTANTS = {
    IMPORT_TITLE: 'Import XLSX attribute values:',
    ADD_VALUE_MODAL_TITLE: 'Add attribute value:',
    LIST_HEIGHT: '1200px',
    CHECKBOX_SIZE: '18px',
    MESSAGE_FONT_SIZE: '32pt',
    SUCCESS: 'Values inserted successfully.',
    FAILED_MESSAGE: 'Unable to Process Request',
    IMPORT_FAILED_MESSAGE: "Import failed. Please check your file and try again"
}

export const ATTRIBUTE_MESSAGES = {
    PLEASE_SELECT_BUSINESS_UNIT: 'Please select business unit.',
    PLEASE_SELECT_ATTRIBUTE: 'Please select an attribute.',
    PLEASE_SELECT_VENDOR: 'Please select a vendor.',
    NO_ATTRIBUTES_AVAILABLE: 'No attributes found',
    LOADING_ATTRIBUTES: 'Loading attributes...',
    ATTRIBUTE_CREATED_SUCCESS: 'Attribute created successfully',
    ATTRIBUTE_UPDATED_SUCCESS: 'Attribute updated successfully',
    ATTRIBUTES_UPDATED_SUCCESS: 'Attributes updated successfully.',
    ATTRIBUTE_DELETED_SUCCESS: 'Attribute deleted successfully',
    ATTRIBUTES_REORDERED_SUCCESS: 'Attributes reordered successfully',
    ATTRIBUTES_MERGED_SUCCESS: 'Attributes merged, please check for duplicate values.',
    ATTRIBUTE_CREATION_FAILED: 'Failed to create attribute',
    ATTRIBUTE_UPDATE_FAILED: 'Failed to update attribute',
    ATTRIBUTE_DELETE_FAILED: 'Failed to delete attribute',
    NO_ATTRIBUTES_FOUND: 'No attributes found for this business unit',
    FAILED_TO_LOAD: 'Failed to load attributes',
    SAVING_ATTRIBUTES: 'The attributes are being saved, please wait...',
    ATTRIBUTES_CREATED_SUCCESS: 'Attributes created successfully',
    ATTRIBUTES_CREATION_FAILED: 'Failed to create attributes',
    DUPLICATE_ATTRIBUTE_NAMES: 'Duplicate attribute names found in the list',
    MAX_ATTRIBUTES_EXCEEDED: 'Maximum 25 attributes allowed',
    AT_LEAST_ONE_ATTRIBUTE: 'Please enter at least one attribute name',
    ATTRIBUTE_NAME_REQUIRED: 'Attribute name is required',
    ATTRIBUTE_ALREADY_EXISTS: 'Attribute already exists',
};

export const ATTRIBUTE_TOOLTIPS = {
    ATTRIBUTES_LIST: 'List of all the attributes for the selected business unit.',
};

export const ATTRIBUTE_TOAST_IDS = {
    UPDATE_ATTRIBUTES: 'updateAttributes',
};

export const ATTRIBUTE_BUTTONS = {
    SAVE: 'Save',
    MERGE: 'Merge',
    SELECT_TO_MERGE: 'Select to merge',
    ADD_ATTRIBUTE: '+ Add new attribute',
    ADD_MORE: '+ Add more',
};

export const ATTRIBUTE_NAME_REGEX = /^[^\d\W][\s\S]*$/;

export const ATTRIBUTE_NAME_ERROR = 'Attribute name cannot start with a number or a symbol.';

// Reserved system attribute names that cannot be used
export const RESTRICTED_ATTRIBUTE_NAMES = ['sku', 'code', 'description', 'weight', 'price', 'vendor', 'log'];

// Helper function to generate error message for restricted names
export const getRestrictedAttributeError = (attributeName) =>
  `${attributeName} is reserved and cannot be used as an attribute name.`;